import { Box, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loading from "../../Loading/Loading";
import FormInfoUser from "./FormInforUser";
import SelectFormAnswers from "./SelectFormAnswers";
import PreferencesUser from "./FormPreferences";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { getUserById } from "../../../services/rest/users/userService";
import { setUserData } from "../../../redux/slice/userSlice";
import { initialState as reduxInitialStateUser } from "../../../redux/slice/userSlice";
import { getAnswersOfUser } from "../../../services/rest/users/medicalQuestions";
import { handleError } from "../../../utils/handleError";
import { getProviderById } from "../../../services/rest/servicesProvider/servicesProvider";

const ProfileUser = () => {
  const { membershipStatus } = useSelector((state) => state.membershipReducer);
  const { userType, status, _id, rol } = useSelector(
    (state) => state.userReducer
  );
  const [loading, setLoading] = useState(true);
  const [selectedChip, setSelectedChip] = useState("profile");
  const [answers, setAnswers] = useState({});
  const dispatch = useDispatch();

  const getDataUser = async () => {
    try {
      let responseUserData;
      if (userType === "user" && rol === "Runner") {
        responseUserData = await getUserById(_id);
        dispatch(
          setUserData({ ...reduxInitialStateUser, ...responseUserData })
        );
        const responseAnswers = await getAnswersOfUser(_id);
        // console.log("responses", responseAnswers);
        setAnswers(responseAnswers ?? {});
        setLoading(false);
      } else if (userType === "provider") {
        responseUserData = await getProviderById(_id);
        responseUserData.rol = responseUserData?.role;
        responseUserData.userType = "provider";
        dispatch(
          setUserData({ ...reduxInitialStateUser, ...responseUserData })
        );
        setLoading(false);
      } else {
        setLoading(false);
        return;
      }
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        `En estos momento no se pudo obtener la información del usuario. \n ${message}`
      );
    }
  };

  useEffect(() => {
    getDataUser();
  }, []);

  return (
    <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 4 }}>
      <Loading loading={loading} />
      <Box sx={{ display: "flex", gap: 5, justifyContent: "center" }}>
        <Chip
          label="Perfil"
          style={
            selectedChip === "profile"
              ? {
                  backgroundColor: "#e7ef7d",
                  color: "black",
                }
              : {}
          }
          onClick={() => {
            setSelectedChip("profile");
          }}
        />
        {userType === "user" && (
          <Chip
            label="Historial Médico"
            variant={"filled"}
            style={
              selectedChip === "medical"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => {
              if (status !== "active" || membershipStatus !== "active") {
                toast.error(
                  `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
                );
                return;
              }
              setSelectedChip("medical");
            }}
          />
        )}
        {userType === "user" && (
          <Chip
            label="Preferencias"
            variant={"filled"}
            style={
              selectedChip === "preferences"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => {
              if (status !== "active" || membershipStatus !== "active") {
                toast.error(
                  `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
                );
                return;
              }
              setSelectedChip("preferences");
            }}
          />
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {selectedChip === "profile" && <FormInfoUser setLoading={setLoading} />}
        {selectedChip === "medical" && (
          <SelectFormAnswers
            TrainAnswers={answers?.entrenamiento ?? {}}
            generalAnswers={answers?.general ?? {}}
            nutricionistAnswers={answers?.nutricion ?? {}}
            phisicalAnswers={answers?.fisico ?? {}}
            psicologyAnswers={answers?.psicologo ?? {}}
            setAnswers={setAnswers}
          />
        )}
        {selectedChip === "preferences" && (
          <Box sx={{ width: 500 }}>
            <PreferencesUser
              preferences={answers?.preferencias ?? {}}
              setAnswers={setAnswers}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProfileUser;
